module.exports = __webpack_public_path__ + "img/Emptying_Fluid.d2c2145d.png";